import { Box, Typography } from '@mui/material';

import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import React from 'react';
import ResponsiveDialog from '/b2b/common/components/ResponsiveDialog';

/*
 * Confirmation dialog for deleting a conversation. Presentational only — the open
 * state, in-flight flag, and error live in the shell.
 */
const DeleteChatDialog = ({ open, onCancel, onConfirm, isLoading, error }) => (
    <ResponsiveDialog
        open={open}
        title="aiAssistant.dialogs.deleteChat.title"
        onCancel={onCancel}
        onClose={onCancel}
        cancelText="common.cancel"
        onConfirm={onConfirm}
        confirmText="common.delete"
        confirmVariant="error"
        isLoading={isLoading}
        error={error}
        size="small"
    >
        <Box>
            <Typography variant="body1" fontWeight="bold" gutterBottom>
                <Locale path="aiAssistant.dialogs.deleteChat.confirm" />
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <Locale path="aiAssistant.dialogs.deleteChat.description" />
            </Typography>
        </Box>
    </ResponsiveDialog>
);

DeleteChatDialog.propTypes = {
    open: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
};

export default DeleteChatDialog;
